import { Button, Modal } from "react-bootstrap";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import Price from "../../../@ui/Price";
import { useCurrencyContext } from "../../../context/Currency/CurrencyContext";

interface LicencePurchaseConfirmationProps {
  licence: LicenceTypePurchase;
  userCount: number;
  onHide: () => void;
}

const LicencePurchaseConfirmation = ({
  licence,
  userCount,
  onHide,
}: LicencePurchaseConfirmationProps) => {
  const { selectedCurrency } = useCurrencyContext();

  const getTotalPrice = () => {
    var prs = licence.pricingRules!.map((x) => ({
      ...x,
      minRange: x.minRange!,
      maxRange: x.maxRange == null ? Infinity : x.maxRange,
    }));

    return Array.from({ length: userCount }, (_, i) => i + 1).reduce(
      (sum, i) => {
        const pr = prs.find((pr) => pr.minRange <= i && pr.maxRange >= i);
        return pr ? sum + pr.transactionCostIncTax : sum;
      },
      0
    );
  };

  return (
    <ThemedModal centered show={true} onHide={onHide} backdrop="static">
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Confirmation</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            You are about to purchase a {licence.name} licence for {userCount}{" "}
            users.
          </p>
          <p>
            The total cost of this purchase is{" "}
            <Price
              price={getTotalPrice()}
              currencyCode={selectedCurrency!.code}
            />
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button>Continue Purchase</Button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default LicencePurchaseConfirmation;
